<script>
import eventBus from '@/js/util/EventBus'

export default {
  inject: ['header'],
  props: {
    disclosureId: {
      type: String,
      required: true,
    },
  },
  created() {
    eventBus.$on('toggle', this.maybeDisclosureToggle)
  },
  methods: {
    maybeDisclosureToggle({ expanded, controls }) {
      if (controls !== this.disclosureId) {
        return
      }
      this.header.$emit('toggle', expanded)
    },
  },
  render: () => null,
}
</script>



// WEBPACK FOOTER //
// src/js/components/HeaderContainerDispatch.vue